import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose } from 'recompose'
import * as routes from '../../../../constants/routes'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography';
import {doDeleteEvent} from '../../../../firebase/db'
import EditIcon from '@material-ui/icons/Edit';
import { doUpdateConnectedEvent } from '../../../../firebase/database/handleEvents'
//import Fab from '@material-ui/core/Fab';
import CloseIcon from '@material-ui/icons/Close'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'

import PropTypes from 'prop-types';

const styles = theme => ({
    paper: {
      padding: theme.spacing.unit*2,
      //marginBottom: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
    },
    textField: {
      marginBottom: theme.spacing.unit ,
    //  marginLeft: theme.spacing.unit,
     // marginRight: theme.spacing.unit,
      
      
    },

    row: {
        border: '2px solid gray',
        padding: '8px',
       // marginRight: '4px',
        display: 'inline-block'
    },
    eventDiv: {
        border: '3px solid gray',
        padding: '20px'
    },
    del: {
        color: 'white',
        textWeight: 'bold',
        padding: '4px',
        marginBottom: '8px',
        backgroundColor: 'red',
        cursor  : 'pointer'
    },
    inlineNav: {
        marginTop: '6px'
    },
    editInfo: {
        cursor: 'pointer'
    },
    inputTextAreaInfo: {
        width: '100%',
        minHeight: '20px'
    },
    closeIcon: {
        float: 'right',
        cursor: 'pointer',
        borderRadius: '12px',
        '&:hover': {
            backgroundColor: '#E8E8E8',
        }
    }
   
  });

  const tempStyle = {
    content: {
     

    },

  rowHeadline: {
      fontWeight: 'bold',
  //    marginBottom: '0.1em',
  },
  rowContent: {
      marginBottom: '0.6em',
      padding: '0.2em',
      borderBottom: '2px solid #3f51b5',
      
  
  },
  rowContentAlert: {
      marginBottom: '0.5em',
      padding: '0.2em',
      borderBottom: '2px solid #f50057',
  },
  rowInfo: {
      color: 'gray',
      font: '1em',
  },
  navFooter: {
      borderTop: '1px solid gray',
      marginTop: '1em'
  }
}


class EventDetails extends Component {

    constructor(props) {
        super(props)
        this.state = {
                infoEdit: false,
                intInfoEdit: false,
                newInfo: this.props.event.event.info || 'Keinen vorhanden',
                newIntInfo: this.props.event.event.intInfo || 'Keine vorhanden'
            }
      }

   

    handleEditInfo = (toggleType) => {
        this.setState({
            [toggleType]: true,

        })
        
    }

    handleSaveInfo = (infoType, toggleType) => {
        this.setState({
            [toggleType]: false,
        })

        const updatedEvent = this.props.event.event
        infoType==='newInfo' ? updatedEvent.info = this.state[infoType] : updatedEvent.intInfo = this.state[infoType]
        
        doUpdateConnectedEvent(updatedEvent)
    }

    handleCloseEditInfo = (type) => {
        this.setState({
            [type]: false
        })
    }

    toggleView = () => {

        if(this.props.type==='connectedEvent') {
            this.props.toggleView('list')
        }
    }
    deleteEvent = (eventId) =>{
        doDeleteEvent(eventId)
        const {history } = this.props
        history.push(routes.ADMINEVENTS)
    }

    
    renderInfoField = (infoType, toggleType) => { 
        const {state} = this
        const { classes } = this.props
        return (  
                <div>
                    {state[toggleType]===true
                       ? <div>
                            <CloseIcon
                                className={classes.closeIcon}
                                onClick={()=>this.handleCloseEditInfo(infoType, toggleType)}
                                color='primary' 
                            />
                            <TextField
                                multiline
                                autoFocus={true}
                                onBlur={()=>this.handleSaveInfo(infoType, toggleType)}
                                value={this.state[infoType]}
                                className={classes.inputTextAreaInfo}
                                onChange={(e)=>this.setState({[infoType]: e.target.value})}
                            />         
                        </div>
                    
                        : <div className={classes.editInfo} style={tempStyle.rowContent} onClick={()=>this.handleEditInfo(toggleType)}>
                            <div  style={{display: 'inline-block', width: '90%'}}>{this.state[infoType]}</div>
                            <div style={{display: 'inline-block'}}><Tooltip title='Ändern'><EditIcon color='primary' /></Tooltip></div>
                        </div>}
                </div>
                             
        )
    }

    render() {

        const { classes, event } = this.props
        const {  date, timeRange, ort, task, pkw, created } = event.event
        const timeStamp = created
        const dateFormatedLong = moment(date).format('dddd DD.MM.YYYY')
        return (
            <div className={styles.inlineBlock}>
                <Paper className={this.props.classes.paper}>
                    <Typography variant="headline" color='primary' gutterBottom>
                        Hilfebedarf
                    </Typography>
                    <div style={tempStyle.content}> 
                        <Typography variant="subheading" gutterBottom>
                            <div style={tempStyle.rowHeadline} >
                                Ausführung:
                            </div>
                            {timeRange==='onDate'
                                ? <div style={tempStyle.rowContentAlert} >Bestimmter Tag</div>
                                : <div style={tempStyle.rowContent} >Nach Vereinbarung</div>
                            }
                            {timeRange==='onDate'
                                ? <div style={tempStyle.rowHeadline} >Datum:</div>
                                : <div style={tempStyle.rowHeadline} >Bis zum: </div>
                            }
                            <div style={tempStyle.rowContent} >{dateFormatedLong}</div>
                            <div style={tempStyle.rowHeadline}>Hilfeleistung</div>
                            <div style={tempStyle.rowContent} >{task}</div>
                            <div style={tempStyle.rowHeadline}>Wohnort:</div>
                            <div style={tempStyle.rowContent} >{ort}</div>
                            <div style={tempStyle.rowHeadline}>PKW erforderlich:</div>
                            {pkw
                                ? <div style={tempStyle.rowContentAlert}>JA</div>
                                : <div style={tempStyle.rowContent}>NEIN</div>
                            }
                            <div style={tempStyle.rowHeadline}>Zusatzinformationen (öffentlich)</div>
                            {this.renderInfoField('newInfo', 'infoEdit')}

                            <div style={tempStyle.rowHeadline} >Interne Infos (nur Admin)</div>
                            {this.renderInfoField('newIntInfo', 'intInfoEdit')}
                        </Typography>
                    
                        <Typography variant="body2" gutterBottom>
                        <div style={styles.row }>Erstellt am {moment(timeStamp).format('dddd DD.MM.YYYY')}</div>
                        <div style={styles.row }>Läuft ab {moment(date, "YYYY-MM-DD").fromNow()}</div>
                        </Typography>  
                    </div>
                    <div style={tempStyle.navFooter}>
                    <Button 
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={()=>this.toggleView()}
                        size="small"
                    >
                        Zurück
                    </Button>
                    </div>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state) =>({
   openEvent: state.adminCanidateState.currentOpenEvent

})

EventDetails.propTypes = {
    openEvent: PropTypes.object.isRequired,
  };


export default compose(
    withRouter,
    connect(mapStateToProps),
    withStyles(styles)
    )   (EventDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/View/EventDetails.js